/**
 * Logo Molecule Component
 * Logo image with home link
 */

import React from 'react';
import { storyblokEditable } from '@/lib/blocks';
import { Image } from '@/components/atoms/Image';
import { Link } from '@/components/atoms/Link';
import { getStoryblokLinkUrl, getStoryblokAssetUrl } from '@/lib/storyblok-utils';
import type { LogoBlok } from '@/types';

export interface LogoProps {
  blok: LogoBlok;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ blok, className = '' }) => {
  const { logo_image, home_link, alt_text } = blok;

  return (
    <div {...storyblokEditable(blok)} className={className}>
      <Link href={getStoryblokLinkUrl(home_link)} className="flex items-center">
        <Image
          src={getStoryblokAssetUrl(logo_image)}
          alt={alt_text}
          className="h-8 w-auto"
        />
      </Link>
    </div>
  );
};

export default Logo;
